<template>
  <div class="internalLinks u-containar">
    <section class="internalLinks_section">
      <HeadingLv3 text="条件から病院を探す" />
      <section
        v-for="(items, index) in conditionsList"
        :key="`conditions_${index}`"
        class="internalLinks_block"
      >
        <h4 class="internalLinks_block_ttl">{{ items.title }}</h4>
        <ul class="internalLinks_block_list">
          <li v-for="(link, key) in items.list" :key="key">
            <a :href="link" v-if="link">{{ key }}</a>
            <span v-else>{{ key }}</span>
          </li>
        </ul>
      </section>
    </section>

    <section class="internalLinks_section">
      <HeadingLv3
        :text="
          areaList.length === 1
            ? '近隣の都道府県から病院を探す'
            : '全国の都道府県から病院を探す'
        "
      />
      <section
        v-for="(items, index) in areaList"
        :key="`area_${index}`"
        class="internalLinks_block -area"
      >
        <h4 v-if="items.title" class="internalLinks_block_ttl">
          {{ items.title }}
        </h4>
        <ul class="internalLinks_block_list">
          <li v-for="(link, key) in items.list" :key="key">
            <a :href="link" v-if="link">{{ key }}</a>
            <span v-else>{{ key }}</span>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

export interface InternalLinksListType {
  [key: string]: any // eslint-disable-line
}
export interface InternalLinksType {
  list: InternalLinksListType
}

export default defineComponent({
  name: 'InternalLinks',

  components: {
    HeadingLv3
  },

  props: {
    list: {
      type: Object as PropType<InternalLinksListType>
    }
  },

  setup(props) {
    const conditionsList = computed(() => {
      return [
        {
          title: '病院種別',
          list: props.list?.hospital_class
        },
        {
          title: '救急指定',
          list: props.list?.designated_hospital
        },
        {
          title: '希望条件',
          list: {
            ...props.list?.bonus,
            ...props.list?.overtime_hours_mavg,
            ...props.list?.house
          }
        },
        {
          title: 'こだわり条件',
          list: props.list?.discerning_conditions
        },
        {
          title: '病床数',
          list: props.list?.bed_num
        },
        {
          title: '医師数',
          list: props.list?.doctor_num
        },
        {
          title: '募集人数',
          list: props.list?.positions_num
        },
        {
          title: '年収',
          list: props.list?.income
        },
        {
          title: '当直回数',
          list: props.list?.shifts_num
        }
      ]
    })

    const areaList = computed(() => {
      const hasArea =
        typeof props.list?.prefectures[
          Object.keys(props.list?.prefectures)[0]
        ] === 'object'

      if (hasArea) {
        return Object.keys(props.list?.prefectures).map((area) => {
          return {
            title: area,
            list: props.list?.prefectures[area]
          }
        })
      }

      return [
        {
          title: '',
          list: props.list?.prefectures
        }
      ]
    })

    return {
      conditionsList,
      areaList
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.internalLinks_section {
  & + & {
    margin-top: 40px;
  }
}

.internalLinks_block {
  margin-top: 20px;

  @include mixins.media() {
    display: inline-block;

    &:nth-of-type(-n + 2) {
      margin-right: 40px;
    }

    &:nth-of-type(n + 4) {
      width: 100%;
    }

    &.-area {
      display: flex;

      &:not(:first-of-type) {
        margin-top: 0;
      }

      .internalLinks_block_ttl {
        flex-basis: 105px;
        min-width: 105px;
        max-width: 105px;
      }
    }
  }

  &_list {
    > li {
      display: inline-block;

      &:not(:last-child) {
        padding-right: 4px;
        margin-right: 4px;

        &:after {
          content: '|';
          color: #666;
          margin-left: 8px;
        }
      }

      > a {
        color: var.$color-main-text;
      }

      > span {
        color: #777;
      }
    }
  }
}
</style>
